import React, { Component } from 'react'

export default function resetHiddenComponent (ComponentInstance) {
  class ResetHiddenComponent extends Component {
    // If the component is going to be hidden, then reset its value
    componentWillUpdate (newProps) {
      if (this.props.hide !== newProps.hide && newProps.hide) {
        this.props.onChange(newProps.initVal ? newProps.initVal : null)
      }
    }

    render () {
      return (
        <div style={{ display: this.props.hide ? 'none' : 'block' }}>
          <ComponentInstance {...this.props} />
        </div>
      )
    }
  }

  return ResetHiddenComponent
}



// WEBPACK FOOTER //
// ./src/components/reset-hidden-components/index.js